import { render, staticRenderFns } from "./ExamReport.vue?vue&type=template&id=5a34144a&scoped=true"
import script from "./ExamReport.vue?vue&type=script&lang=js"
export * from "./ExamReport.vue?vue&type=script&lang=js"
import style0 from "./ExamReport.vue?vue&type=style&index=0&id=5a34144a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a34144a",
  null
  
)

export default component.exports